module.exports = __webpack_public_path__ + "img/hoovers.3480d2ed.png";